import { useLocalePrefix } from "@/app/_utilities/i18n";
import { translateWithFallback } from "@/app/_utilities/translateWithFallback";
import ArrowUpRight16 from "@ui/icons/16x16/arrow-up-right-16.svg";
import { useTranslations } from "next-intl";

type ATagProps = React.ComponentPropsWithoutRef<"a">;

type FlagPillProps = {
  flag: React.ReactNode;
  hideArrow?: boolean;
  href: string;
  name: string;
} & ATagProps;

export const FlagPill = ({ name, flag, href, hideArrow = false, ...rest }: FlagPillProps) => {
  const localeKey = useLocalePrefix();
  const t = useTranslations("ClientKeys.LanguagesAndAccents");
  const translatedName = translateWithFallback(t, name);

  return (
    <a
      className='f-ui-04 flex w-full items-center justify-between overflow-hidden rounded-full border bg-default p-8 md:f-ui-03 hover:border-darkest'
      href={`${localeKey}${href}`}
      {...rest}
    >
      <div className='flex items-center'>
        <div>{flag}</div>
        <div className='mx-8 whitespace-nowrap'>{translatedName}</div>
      </div>
      {!hideArrow && (
        <div className='mr-4 text-light'>
          <ArrowUpRight16 />
        </div>
      )}
    </a>
  );
};
